export const OBJECTIVE_EVENT_NAMES = {
  CLICKED_OPEN_ASSESSMENT: 'Clicked Open Assessment',
  CLICKED_PRINT_OBJECTIVE: 'Clicked Print Objective',
  CLICKED_OBJECTIVE_TAB: 'Clicked Objective Tab'
}
